import React, { useState } from 'react';
import * as XLSX from 'xlsx';
import api from '../api';
import { FaFileExcel, FaDownload, FaUpload, FaTimes } from 'react-icons/fa';

const ProdutosSemControleImport = ({ fecharModal, recarregar }) => {
    const [arquivo, setArquivo] = useState(null);
    const [processando, setProcessando] = useState(false);
    const [resultado, setResultado] = useState(null);

    const baixarTemplate = () => {
        const template = [
            {
                'Nome': 'Ovo (exemplo)',
                'Unidade': 'unidade',
                'Peso Embalagem': '1',
                'Custo Fixo': '0.50',
                'Observações': 'Ovos brancos tamanho grande'
            },
            {
                'Nome': 'Corante Vermelho (exemplo)',
                'Unidade': 'l',
                'Peso Embalagem': '1.000',
                'Custo Fixo': '45.00',
                'Observações': 'Corante líquido - comprado por litro'
            },
            {
                'Nome': 'Açúcar Refinado (exemplo)',
                'Unidade': 'kg',
                'Peso Embalagem': '5.000',
                'Custo Fixo': '12.50',
                'Observações': 'Pacote de 5kg'
            },
            {
                'Nome': 'Caixa de Papelão (exemplo)',
                'Unidade': 'caixa',
                'Peso Embalagem': '1',
                'Custo Fixo': '2.00',
                'Observações': 'Caixa para transporte'
            }
        ];

        const ws = XLSX.utils.json_to_sheet(template);
        
        // Ajustar largura das colunas
        ws['!cols'] = [
            { wch: 35 }, // Nome
            { wch: 12 }, // Unidade
            { wch: 18 }, // Peso Embalagem
            { wch: 15 }, // Custo Fixo
            { wch: 40 }  // Observações
        ];

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Produtos Sem Controle');
        
        // Adicionar instruções em outra aba
        const instrucoes = [
            { 
                'Campo': 'Nome', 
                'Descrição': 'Nome do produto (obrigatório)', 
                'Exemplo': 'Ovo, Corante Vermelho, Açúcar' 
            },
            { 
                'Campo': 'Unidade', 
                'Descrição': 'Unidade de medida (obrigatório) - APENAS: unidade, caixa, kg, l', 
                'Exemplo': 'unidade, caixa, kg, l' 
            },
            { 
                'Campo': 'Peso Embalagem', 
                'Descrição': 'Quantidade da embalagem (obrigatório para kg e l)', 
                'Exemplo': '1 (unidade/caixa), 1.000 (1kg), 5.000 (5kg), 2.000 (2 litros)' 
            },
            { 
                'Campo': 'Custo Fixo', 
                'Descrição': 'Custo em reais (opcional)', 
                'Exemplo': '0.50, 3.00, 15.99' 
            },
            { 
                'Campo': 'Observações', 
                'Descrição': 'Informações adicionais (opcional)', 
                'Exemplo': 'Qualquer observação relevante' 
            }
        ];

        const wsInst = XLSX.utils.json_to_sheet(instrucoes);
        wsInst['!cols'] = [
            { wch: 20 },
            { wch: 50 },
            { wch: 40 }
        ];
        XLSX.utils.book_append_sheet(wb, wsInst, 'Instruções');

        XLSX.writeFile(wb, 'template_produtos_sem_controle.xlsx');
    };

    const handleArquivoChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            if (!file.name.endsWith('.xlsx') && !file.name.endsWith('.xls')) {
                alert('Por favor, selecione um arquivo Excel (.xlsx ou .xls)');
                return;
            }
            setArquivo(file);
            setResultado(null);
        }
    };

    // ✅ APENAS 4 UNIDADES VÁLIDAS
    const validarUnidade = (unidade) => {
        const unidadesValidas = ['unidade', 'caixa', 'kg', 'l'];
        return unidadesValidas.includes(unidade.toLowerCase().trim());
    };

    const processarArquivo = async () => {
        if (!arquivo) {
            alert('Selecione um arquivo primeiro');
            return;
        }

        setProcessando(true);
        setResultado(null);

        try {
            const data = await arquivo.arrayBuffer();
            const workbook = XLSX.read(data);
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];
            const produtos = XLSX.utils.sheet_to_json(worksheet);

            console.log('📦 Produtos lidos do Excel:', produtos);

            if (produtos.length === 0) {
                alert('O arquivo está vazio ou não possui dados válidos');
                setProcessando(false);
                return;
            }

            let sucessos = 0;
            let erros = [];

            for (let i = 0; i < produtos.length; i++) {
                const linha = i + 2; // +2 porque linha 1 é cabeçalho e Excel começa em 1
                const p = produtos[i];

                // Validações
                if (!p.Nome || p.Nome.trim() === '') {
                    erros.push(`Linha ${linha}: Nome é obrigatório`);
                    continue;
                }

                if (!p.Unidade || p.Unidade.trim() === '') {
                    erros.push(`Linha ${linha}: Unidade é obrigatória`);
                    continue;
                }

                const unidade = p.Unidade.toLowerCase().trim();
                if (!validarUnidade(unidade)) {
                    erros.push(`Linha ${linha}: Unidade inválida. Use apenas: unidade, caixa, kg ou l`);
                    continue;
                }

                // ✅ PESO EMBALAGEM - OBRIGATÓRIO PARA KG E L
                let pesoEmbalagem = 1;
                if (unidade === 'kg' || unidade === 'l') {
                    if (!p['Peso Embalagem']) {
                        erros.push(`Linha ${linha}: Peso Embalagem é obrigatório para ${unidade}`);
                        continue;
                    }
                    
                    // Converter vírgula para ponto
                    const pesoStr = String(p['Peso Embalagem']).replace(',', '.');
                    pesoEmbalagem = parseFloat(pesoStr);
                    
                    if (isNaN(pesoEmbalagem) || pesoEmbalagem <= 0) {
                        erros.push(`Linha ${linha}: Peso Embalagem inválido (use formato: 1.000 ou 5.000)`);
                        continue;
                    }
                } else {
                    // Para unidade e caixa, sempre 1
                    pesoEmbalagem = 1;
                }

                // Custo fixo
                let custoFixo = null;
                if (p['Custo Fixo']) {
                    const custoStr = String(p['Custo Fixo']).replace(',', '.');
                    custoFixo = parseFloat(custoStr);
                    if (isNaN(custoFixo)) {
                        erros.push(`Linha ${linha}: Custo Fixo inválido`);
                        continue;
                    }
                }

                // Enviar para API
                try {
                    await api.post('/produtos-sem-controle', {
                        nome: p.Nome.trim(),
                        unidade_peso: unidade,
                        peso_embalagem: pesoEmbalagem,
                        custo_fixo: custoFixo,
                        observacoes: p['Observações'] ? p['Observações'].trim() : null
                    });
                    sucessos++;
                } catch (error) {
                    const mensagemErro = error.response?.data?.error || error.message;
                    erros.push(`Linha ${linha} (${p.Nome}): ${mensagemErro}`);
                }
            }

            setResultado({
                total: produtos.length,
                sucessos,
                erros
            });

            if (sucessos > 0) {
                recarregar();
            }

        } catch (error) {
            console.error('Erro ao processar arquivo:', error);
            alert('Erro ao processar arquivo. Verifique se está no formato correto.');
        } finally {
            setProcessando(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
                <div className="p-6">
                    {/* Header */}
                    <div className="flex justify-between items-center mb-6">
                        <h3 className="text-xl font-semibold text-gray-800 flex items-center gap-2">
                            <FaFileExcel className="text-green-600" />
                            Importar Produtos sem Controle
                        </h3>
                        <button
                            onClick={fecharModal}
                            className="text-gray-500 hover:text-gray-700 text-2xl"
                        >
                            <FaTimes />
                        </button>
                    </div>

                    {/* Instruções */}
                    <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
                        <h4 className="font-semibold text-blue-900 mb-2">📋 Como usar:</h4>
                        <ol className="list-decimal list-inside space-y-1 text-sm text-blue-800">
                            <li>Baixe o template Excel clicando no botão abaixo</li>
                            <li>Preencha os dados dos produtos (veja os exemplos)</li>
                            <li>Salve o arquivo e faça o upload aqui</li>
                            <li>Aguarde o processamento</li>
                        </ol>
                        
                        <div className="mt-3 text-sm text-blue-700">
                            <strong>Unidades válidas:</strong> unidade, caixa, kg, l<br />
                            <strong>Importante:</strong> Para kg e l, informe o peso da embalagem (ex: 1.000, 5.000)
                        </div>
                    </div>

                    {/* Botão Download Template */}
                    <button
                        onClick={baixarTemplate}
                        className="w-full bg-green-600 text-white px-4 py-3 rounded-lg hover:bg-green-700 transition flex items-center justify-center gap-2 mb-4"
                    >
                        <FaDownload />
                        Baixar Template Excel
                    </button>

                    {/* Upload */}
                    <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center mb-4">
                        <input
                            type="file"
                            accept=".xlsx,.xls"
                            onChange={handleArquivoChange}
                            className="hidden"
                            id="file-upload"
                        />
                        <label
                            htmlFor="file-upload"
                            className="cursor-pointer flex flex-col items-center gap-2"
                        >
                            <FaUpload className="text-4xl text-gray-400" />
                            <span className="text-gray-600">
                                {arquivo ? arquivo.name : 'Clique para selecionar arquivo Excel'}
                            </span>
                            <span className="text-sm text-gray-500">
                                Formatos aceitos: .xlsx, .xls
                            </span>
                        </label>
                    </div>

                    {/* Botão Importar */}
                    <button
                        onClick={processarArquivo}
                        disabled={!arquivo || processando}
                        className="w-full bg-blue-600 text-white px-4 py-3 rounded-lg hover:bg-blue-700 transition disabled:bg-gray-300 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                    >
                        {processando ? (
                            <>
                                <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
                                Processando...
                            </>
                        ) : (
                            <>
                                <FaFileExcel />
                                Importar Produtos
                            </>
                        )}
                    </button>

                    {/* Resultado */}
                    {resultado && (
                        <div className="mt-6">
                            <div className={`p-4 rounded-lg ${
                                resultado.erros.length === 0 
                                    ? 'bg-green-50 border border-green-200' 
                                    : 'bg-yellow-50 border border-yellow-200'
                            }`}>
                                <h4 className="font-semibold mb-2">
                                    📊 Resultado da Importação
                                </h4>
                                <div className="space-y-1 text-sm">
                                    <p>✅ Total processado: {resultado.total}</p>
                                    <p className="text-green-700">✅ Importados com sucesso: {resultado.sucessos}</p>
                                    {resultado.erros.length > 0 && (
                                        <p className="text-red-700">❌ Erros: {resultado.erros.length}</p>
                                    )}
                                </div>

                                {resultado.erros.length > 0 && (
                                    <div className="mt-4">
                                        <h5 className="font-semibold text-red-700 mb-2">Detalhes dos erros:</h5>
                                        <div className="max-h-40 overflow-y-auto bg-white rounded p-2 text-xs">
                                            {resultado.erros.map((erro, idx) => (
                                                <div key={idx} className="text-red-600 py-1 border-b last:border-b-0">
                                                    {erro}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>

                            {resultado.sucessos > 0 && (
                                <button
                                    onClick={fecharModal}
                                    className="w-full mt-4 bg-gray-200 text-gray-700 px-4 py-2 rounded-lg hover:bg-gray-300"
                                >
                                    Fechar
                                </button>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ProdutosSemControleImport;